module.exports = __webpack_public_path__ + "img/tacostequila.2871e582.jpg";